'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from '@spa/components/game-inscription/game-inscription.component';
import dynamic from 'next/dynamic';

const DynamicGameInscriptionComponent: ComponentType<Props> = dynamic(
  () => import('@spa/components/game-inscription/game-inscription.component')
);

export default DynamicGameInscriptionComponent;

export function calculateGameInscriptionPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 162 },
    { sinceWidth: 768, height: 192 }
  ];

  return {
    heightSinceWidth
  };
}
